export const uniqueClassificationIds = (
  ids: Array<string | null | undefined>,
): string[] =>
  Array.from(new Set(ids.filter((id): id is string => Boolean(id))));

export const classificationIdsChanged = (
  currentIds: string[],
  nextIds: string[],
): boolean =>
  currentIds.length !== nextIds.length ||
  nextIds.some((id) => !currentIds.includes(id));
